import {button,escapeHtml,message} from '../ui/components.js';

const MASS_UNITS=Object.freeze([['g','g'],['kg','kg'],['oz','oz'],['lb','lb']]);

function productOptions(catalogue=[],customProducts=[],selected=''){
  const global=(catalogue||[]).map(item=>{
    const code=String(item?.code||'').trim();
    const label=String(item?.displayName||item?.labels?.pl||item?.displayNamePl||code).trim();
    return {value:'catalogue:'+code,label};
  }).filter(item=>item.value!=='catalogue:');
  const custom=(customProducts||[]).filter(item=>!item?.archivedAt).map(item=>({
    value:'custom:'+String(item?.id||'').trim(),
    label:'Własne: '+String(item?.name||'').trim()
  })).filter(item=>item.value!=='custom:');

  return [...global,...custom].map(item=>
    '<option value="'+escapeHtml(item.value)+'"'+(item.value===selected?' selected':'')+'>'+escapeHtml(item.label)+'</option>'
  ).join('');
}

function unitOptions(selected){
  return MASS_UNITS.map(([value,label])=>
    '<option value="'+value+'"'+(value===selected?' selected':'')+'>'+label+'</option>'
  ).join('');
}

function selectedSource(item){
  if(item?.catalogueProductCode)return 'catalogue:'+item.catalogueProductCode;
  if(item?.customProductId)return 'custom:'+item.customProductId;
  return '';
}

function itemRow(item,index,total,editable){
  const mass=item.mass==null?'':String(item.mass)+' '+String(item.massUnit||'');
  const quantity=item.quantity==null?'':String(item.quantity)+' szt.';
  const controls=editable
    ?'<div class="actions compact">'+
      button({label:'Edytuj',variant:'secondary',attributes:{'data-journal-item-edit':item.id}})+
      button({label:'↑',variant:'ghost',disabled:index===0,attributes:{'data-journal-item-up':item.id}})+
      button({label:'↓',variant:'ghost',disabled:index===total-1,attributes:{'data-journal-item-down':item.id}})+
      button({label:'Usuń',variant:'danger',attributes:{'data-journal-item-remove':item.id}})+
      '</div>'
    :'';
  const meta=[mass.trim(),quantity].filter(Boolean).join(' · ')||'Bez ilości';
  return '<article class="panel journal-item-row"><div><strong>'+escapeHtml(item.nameSnapshot)+'</strong><p>'+
    escapeHtml(meta)+'</p></div>'+controls+'</article>';
}

export function smokingItemEditorMarkup({
  items=[],
  catalogue=[],
  customProducts=[],
  editingItem=null,
  offline=false,
  sessionStatus='draft'
}={}){
  const editable=['draft','planned','preparation','ready'].includes(String(sessionStatus||'').toLowerCase());
  const source=selectedSource(editingItem);
  const list=(items||[]).length
    ?items.map((item,index)=>itemRow(item,index,items.length,editable)).join('')
    :'<p class="panel-copy">Dodaj pierwszy produkt do tego wędzenia.</p>';

  const lockNotice=editable?'':message({
    text:'Lista produktów jest zablokowana po rozpoczęciu właściwego procesu wędzenia.',
    kind:'warning'
  });
  const offlineNotice=offline?message({
    text:'Pracujesz offline. Zmiany zostaną zapisane lokalnie i oczekują na synchronizację.',
    kind:'warning'
  }):'';

  const form=editable
    ?'<form id="smoking-item-form" class="smoker-form" novalidate>'+
      offlineNotice+
      '<div class="smoker-form-section"><h2>'+(editingItem?'Edytuj produkt':'Dodaj produkt')+'</h2>'+
      '<div class="form-grid">'+
      '<label class="field"><span class="field-label">Produkt</span><select name="productSource" required><option value="">Wybierz…</option>'+
      productOptions(catalogue,customProducts,source)+'</select></label>'+
      '<label class="field"><span class="field-label">Liczba sztuk</span><input name="quantity" type="number" min="0.001" step="0.001" value="'+escapeHtml(editingItem?.quantity??'')+'"></label>'+
      '<label class="field"><span class="field-label">Masa</span><input name="mass" type="number" min="0.001" step="0.001" value="'+escapeHtml(editingItem?.mass??'')+'"></label>'+
      '<label class="field"><span class="field-label">Jednostka masy</span><select name="massUnit"><option value="">—</option>'+
      unitOptions(editingItem?.massUnit||'')+'</select></label>'+
      '</div></div><div class="actions">'+button({label:editingItem?'Zapisz zmiany':'Dodaj produkt',type:'submit'})+
      (editingItem?button({id:'cancel-smoking-item-edit',label:'Anuluj',variant:'ghost'}):'')+
      '</div></form>'
    :'';

  return '<section class="journal-item-editor">'+lockNotice+
    '<div class="journal-item-list">'+list+'</div>'+form+'</section>';
}
